/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Center, Container, Flex, Text } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import BreadcrumbComponent from '../../../components/BreadcrumbComponent/BreadcrumbComponent.js';
import Company from '../../../components/Company.js';
import NoData from '../../../components/NoData.js';
import PrintLayout from '../../../components/Print/PrintLayout.js';
import c from '../../../constant';
import useStore from '../../../store/index.js';
import { EWSTypeStatement, getDefaultFilterOptionValue, getFilterOptions } from '../../../utils/ews.js';
import { mappingKhmerNumber } from '../../../utils/market-development.js';
import Filter from '../../EarlyWarning/components/ews-annually-summary-filter.js';
import { getFilterTitle, getYear } from '../../EarlyWarning/utils.js';
import InvestmentReportSpreadSheetTable from '../../EarlyWarning/components/AnnuallySummarizedIRReport/InvestmentReportSpreadSheetTable.js';
import ExportExcelSummarizedReportIR from '../../../components/EarlyWarning/SummarizedReport/AnnuallyExcelSummarizedReportIR.js';

function AnnuallySummarizedInvestmentReportDM({ industrial = true }) {
	const location = useLocation();
	const history = useHistory();
	const urlParams = new URLSearchParams(location.search);
	const reportId = urlParams.get('reportId') || null;
	const report = urlParams.get('report') || null;
	const years = urlParams.get('years') ?? null;
	const companyType = urlParams.get('companyType') || null;
	const companyId = urlParams.get('companyId') || null;
	const { t } = useTranslation();
	const { currentLang: lang } = useStore((state) => state?.currentLang);
	const [exportIR, setExportIR] = useState(null);

	const { currentUser: user } = useStore((state) => state?.currentUser);
	const [filterOptions, setFilterOptions] = useState([]);
	const [isPermitted, setPermitted] = useState(false);
	const [title, setTitle] = useState(null);
	useEffect(() => setFilterOptions(getFilterOptions({ industrial, user })), [user]);
	useEffect(() => setPermitted(filterOptions?.length > 0), [filterOptions]);
	useEffect(() => setTitle(companyType ? companyType : getDefaultFilterOptionValue({ filterOptions })), [companyType, filterOptions]);

	return (
		<PrintLayout>
			<Container maxW="container.xl" mt="16px" mb="16px">
				<BreadcrumbComponent
					list={[
						{
							name: 'Insurance Market Data',
							path: `/insurance-market-data`,
						},
						{
							name: 'Annually Investment Summarized Report',
							path: '#',
						},
					]}
				/>
				<Center mt="5">
					<Box
						w="100%"
						bg="white"
						borderRadius={c.borderRadius}
						border="1px solid #dbdbdb"
						boxShadow="0 1px 2px rgba(var(--black, #000), 0.1)"
						pb="32px"
					>
						<Flex
							className="hidden-print"
							bg="#FAFAFA"
							p="16px"
							pt="8px"
							pb="8px"
							mb="0px"
							alignItems="center"
							justifyContent="space-between"
							borderBottom="1px solid #dbdbdb"
						>
							<Text fontSize="x-large" fontWeight="bold">
								{t('Annually Investment Summarized Report')}
							</Text>
							<Flex>
								{isPermitted && <ExportExcelSummarizedReportIR object={exportIR} mr={2} />}
								{isPermitted && (
									<Filter
										industrial={industrial}
										reportId={reportId}
										report={report}
										years={years}
										companyId={companyId}
										companyType={companyType}
										onCallback={(url) => history.push(`/insurance-market-data/industry-annually-summarized-ir-report${url}`)}
									/>
								)}
							</Flex>
						</Flex>
						{isPermitted ? (
							<>
								<Flex flexDirection="column" justifyContent="center" alignItems="center" pt={4} pl={4} pr={4} pb={1}>
									<Text fontSize="xl" fontWeight="700" color="blue.500" mb={1}>
										{t(getFilterTitle({ title, industrial }))}
									</Text>
									{companyId && (
										<Box mb={1}>
											<Company id={companyId} color="blue.500" />
										</Box>
									)}
									<Text fontSize="xl" fontWeight="700" color="blue.500">
										{(function () {
											if (years) {
												const parsed = JSON.parse(years)
													.map((year) => parseInt(year))
													.sort((a, b) => (a > b ? 1 : -1));
												if (parsed?.length > 0) {
													const ys = parsed?.map((p) => (lang === 'kh' ? mappingKhmerNumber(getYear(p)) : `${getYear(p)}`));
													return ys.join(', ');
												}
											}
											return lang === 'kh' ? mappingKhmerNumber(getYear(null)) : `${getYear(null)}`;
										})()}
									</Text>
								</Flex>
								<Box pt={2} pl={4} pr={4}>
									<InvestmentReportSpreadSheetTable
										filterOptions={filterOptions}
										years={years}
										companyType={companyType}
										companyId={industrial ? null : companyId}
										type={EWSTypeStatement.an}
										onReadyForExport={(result) => setExportIR(result)}
									/>
								</Box>
							</>
						) : (
							<>
								<NoData />
							</>
						)}
					</Box>
				</Center>
			</Container>
		</PrintLayout>
	);
}

export default AnnuallySummarizedInvestmentReportDM;
